import type { InjectionKey, Ref } from 'vue'
import type { Ocid } from '@/composition/global/useDeepLinking'

export const OcidKey: InjectionKey<Ocid> = Symbol('Ocid')
